
export default {
  fillAvailable: {
    width: '-webkit-fill-available'
  },
  ruby: {
    display: 'ruby',
  },
  container: {
    padding: '20px',
  },
  inline: {
    display: 'inline',
  },
  inlineFlex: {
    display: 'inline-flex',
  },
  inlineGrid: {
    display: 'inline-grid',
  },
  flex: {
    display: 'flex',
  },
  alignStart: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  spaceBetweenStart: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  spaceBetweenEnd: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  spaceBetween: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  spaceAround: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  alignStartColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  alignCenterColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  alignEndColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  alignJustifyCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  justifyCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  justifyEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  alignEnd: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  flexWrap: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  m5: {
    margin: '5px',
  },
  m10: {
    margin: '10px',
  },
  m20: {
    margin: '20px',
  },
  m30: {
    margin: '30px',
  },
  m50: {
    margin: '50px',
  },
  mt5: {
    marginTop: '5px',
  },
  mt10: {
    marginTop: '10px',
  },
  mt20: {
    marginTop: '20px',
  },
  mt30: {
    marginTop: '30px',
  },
  mt40: {
    marginTop: '40px',
  },
  mt120: {
    marginTop: '120px',
  },
  mr5: {
    marginRight: '5px',
  },
  mr10: {
    marginRight: '10px',
  },
  mr15: {
    marginRight: '15px',
  },
  mr20: {
    marginRight: '20px',
  },
  mr30: {
    marginRight: '30px',
  },
  mr40: {
    marginRight: '40px',
  },
  mr50: {
    marginRight: '50px',
  },
  ml5: {
    marginLeft: '5px',
  },
  ml10: {
    marginLeft: '10px',
  },
  ml15: {
    marginLeft: '15px',
  },
  ml20: {
    marginLeft: '20px',
  },
  ml30: {
    marginLeft: '30px',
  },
  ml40: {
    marginLeft: '40px',
  },
  ml50: {
    marginLeft: '50px',
  },
  pb5: {
    paddingBottom: '5px',
  },
  mb5: {
    marginBottom: '5px',
  },
  mb10: {
    marginBottom: '10px',
  },
  mb20: {
    marginBottom: '20px',
  },
  mb30: {
    marginBottom: '30px',
  },
  mb40: {
    marginBottom: '40px',
  },
  mb50: {
    marginBottom: '50px',
  },
  mb100: {
    marginBottom: '100px',
  },
  p5: {
    padding: '5px',
  },
  pt5: {
    paddingTop: '5px',
  },
  pt60: {
    paddingTop: '60px',
  },
  pr5: {
    paddingRight: '5px',
  },
  pr10: {
    paddingRight: '10px',
  },
  pr20: {
    paddingRight: '20px',
  },
  p10: {
    padding: '10px',
  },
  p20: {
    padding: '20px',
  },
  p30: {
    padding: '30px',
  },
  p50: {
    padding: '50px',
  },
  pb20: {
    paddingBottom: '20px',
  },
  pb30: {
    paddingBottom: '30px',
  },
  pb40: {
    paddingBottom: '40px',
  },
  pb50: {
    paddingBottom: '50px',
  },
  pb60: {
    paddingBottom: '60px',
  },
  pb120: {
    paddingBottom: '120px',
  },
  plr10: {
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  plr20: {
    padding: '20px 0',
  },
  pl5: { paddingLeft: '5px' },
  pl10: { paddingLeft: '10px' },
  pl50: { paddingLeft: '50px' },
  pt20: { paddingTop: '20px' },
  pt50: { paddingTop: '50px' },
  uppercase: {
    textTransform: 'uppercase',
  },
  relative: { position: 'relative' },
  absolute: { position: 'absolute' },
  pointer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  link: {
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  unselectable: {
    userSelect: 'none',
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
  fw: {
    width: '100%',
  },
  red: {
    color: 'red',
  },
  w100: {
    width: '100px',
  },
  w200: {
    width: '200px',
  },
  w300: {
    width: '300px',
  },
  subHead: {
    color: '#FDFDFD',
    fontSize: '20px',
    padding: '10px 35px',
    backgroundColor: '#eeecf8',
  },
  op5: {
    opacity: '0.5',
  },
  hoverOp1: {
    '&:hover': {
      opacity: 1,
    },
  },
  col50: {
    width: '50%',
  },
  trplBtn: {
    textTransform: 'uppercase',
    fontSize: 11,
    height: '24px',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    padding: '2px 16px 2px 16px',
    //backgroundImage: 'linear-gradient(to right, #E0EAFC 0%,rgb(207, 207, 243) 51%, #E0EAFC 100%)',
    backgroundImage: 'linear-gradient(to right, #E0EAFC 0%,rgb(255, 255, 255) 51%,rgb(224, 224, 252) 100%)',
    textAlign: 'center',
    border: '1px solid transparent',
    textTransform: 'uppercase',
    backgroundSize: '200% auto',
    boxShadow: '0 0 20px #eee',
    borderRadius: '20px',
    transition: '0.5s',
    '&:hover': {
      color: '#fff',
      backgroundImage: 'linear-gradient(to right,rgb(18, 31, 57) 0%,rgb(44, 44, 69) 51%,rgb(36, 49, 73) 100%)',
      backgroundPosition: 'right center',
      //border: '1px solid #ffffff',
      textDecoration: 'none',
    },
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    fontSize: 12,
    minWidth: '69px',
    minHeight: '22px',
    cursor: 'pointer',
    boxShadow: 'none',
    borderRadius: '20px',
    lineHeight: 'normal',
    textTransform: 'uppercase',
  },
  btnGray: {
    border: 'none',
    fontSize: 12,
    minWidth: '69px',
    color: '#4E4C4C',
    boxShadow: 'none',
    borderRadius: '20px',
    lineHeight: 'normal',
    background: '#BDC7E2',
    textTransform: 'none',
    padding: '3.36px 15px 4px 15px',
    '&:hover': {
      background: '#eeecf8',
      '& .btn-gray-icon': {
        color: '#4E4C4C',
      },
    },
  },
  btnGrayIcon: {
    color: '#e8e8f7',
    fontSize: '17px',
  },
  btnEmpty: {
    background: 'transparent',
    '&:hover': {
      background: '#E8EAF6',
    },
  },
  btnNormal: {
    display: 'flex',
    fontSize: 12,
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: '22px',
    color: '#4C4C4C',
    background: '#E8EAF6',
    borderBottom: '1px solid #00000015',
    '&:hover': {
      opacity: '0.9',
      background: '#222029',
      color: '#fff',
      '& .btn-icon': {
        color: '#fff',
      },
    },
  },
  btnNormalDisabled: {
    background: '#F2F1FB !important',
    color: '#878787 !important',
  },
  btnRenderParts: {
    fontSize: 12,
    padding: '4px 10px 3px 15px',
    textTransform: 'capitalize',
  },
  btnIcon: {
    fontSize: 18,
  },
  btnBig: {
    fontSize: '14px',
    padding: '5px 8px 5px 8px',
    borderRadius: '5px',
    boxShadow: 'none',
    border: 'none',
    minWidth: '80px',
    height: '32px',
    textTransform: 'capitalize',
  },
  btnBigEmpty: {
    color: '#54476B',
    background: 'transparent',
    '&:hover': {
      background: '#fff',
    },
  },
  btnBigNormal: {
    background: '#222029',
    opacity: '0.9',
    color: '#fff',
    '&:hover': {
      background: '#222029',
      opacity: '1.0',
    },
  },
  btnDownload: {
    color: '#C4C4C4',
    background: 'transparent',
    '&:hover': {
      color: '#4E4C4C',
      cursor: 'pointer',
    },
  },
  trplFormPaper: {
    overflowX: 'hidden',
    background: "linear-gradient(90deg, #ECE9F4 0%, #EBF0F8 50%, #EBF0F8 100%)",//'#F2F1FB',
  },
  howerRedColor: {
    '&:hover': {
      color: 'red !important',
    },
  },
  trplSelectContainer: {
    background: '#e8ebf5',
    '&:hover': {
      background: '#eeecf8',
      '& .MuiSelect-icon': {
        color: '#6e6e98',
      },
    },
  },
  bold: {
    fontWeight: '900',
  },
  trplSelectMenu: {
    boxShadow: '0 5px 5px -3px rgba(0,0,0,0.2)',
    '&::-webkit-scrollbar': {
      width: '3px',
      backgroundColor: 'rgba(0,0,0, 0.2)',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
      backgroundColor: '#BCBCBC',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#878787',
      borderRadius: '10px',
    },
    '& .MuiSelect-select.MuiSelect-select': {
      backgroundColor: '#D9D8ED',
    },
    '& .MuiListItem-root': {
      '&:hover': {
        backgroundColor: '#D9D8ED',
      },
    },
    '& .MuiListItem-root.Mui-selected': {
      backgroundColor: '#eeecf8',
      '&:hover': {
        backgroundColor: '#D9D8ED',
      },
    },
    '& .MuiButtonBase-root-MuiMenuItem-root.Mui-selected': {
      backgroundColor: '#eeecf8',
      '&:hover': {
        backgroundColor: '#D9D8ED',
      },
    }
  },
  styledScroll: {
    '&::-webkit-scrollbar': {
      width: '3px',
      background: 'rgba(0,0,0, 0.2)',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
      background: '#BCBCBC',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#878787',
      borderRadius: '10px',
    },
  },
  trplSelect: {
    width: '-webkit-fill-available',
    padding: '0 5px',
    minHeight: '19px',
    maxHeight: '24px',
    minWidth: '40px',
  },
  deleteBtnIcon: {
    color: '#989898',
    '&:hover': {
      color: '#E91818',
      cursor: 'pointer',
    },
  },
  trplSelectIcon: {
    fontSize: '18px',
    color: '#8589AC',
  },
  textRight: {
    textAlign: 'right',
  },
  textCenter: {
    textAlign: 'center',
  },
  mandatoryField: {
    background: '#FFD3B5 !important',
  },
  muiTooltip: {
    color: '#fff',
    fontSize: '12px',
    marginBottom: 5,
    marginTop: '9px',
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    padding: '1px 5px 2px 5px',
    backgroundColor: '#4E4C4C',
  },
  selectPlaceholderItalic: {
    color: '#7978A8',
    fontSize: 12,
    fontStyle: 'italic',
  },
  hide: {
    display: 'none',
  },
  noPointerEvents: {
    pointerEvents: 'none',
  },
  resizableTextarea: {
    maxHeight: '1000px',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
  },
  draggableItemHelper: {
    zIndex: 99999,
    backgroundColor: '#fff',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16);',
    '& .drag-handle-icon': {
      color: '#4E4C4C',
    },
  },
  tableHeading: {
    fontSize: 12,
    fontWeight: 600,
    color: '#878787',
    lineHeight: '16px',
    verticalAlign: 'top',
    padding: '0px 10px 5px 0px',
    textTransform: 'none',
  },
  tabsContainer: {
    display: 'flex',
    background: '#fff',
    alignItems: 'flex-end',
  },
  tabs: {
    minHeight: 0,
    background: '#fff',
    flex: 1,
    display: 'flex',
    '& .MuiTab-root': {
      minWidth: '50px',
      fontSize: '12px',
      padding: '6px 20px',
    },
    '& .MuiTabs-flexContainer': {
      justifyContent: 'center',
    },
    '& .MuiTab-wrapper': {
      textTransform: 'none',
      flexDirection: 'row',
    },
    '& .Mui-selected .MuiTab-wrapper': {
      fontWeight: 500,
    },
    '& .MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
      marginBottom: 0,
    },
    '& .MuiTabs-indicator': {
      color: 'red',
    },
    '& .MuiTab-labelIcon': {
      minHeight: 0,
      padding: '10px 20px',
    },
  },
  table: {
    marginTop: '10px',
    width: '100%',
    color: '#4E4C4C',
    marginBottom: 80,
    maxWidth: '1200px',
    '& .MuiTableBody-root': {
      background: '#fff',
    }
  },
  tableRow: {
    //backgroundColor: '#fff',
    display: 'table-row',
    borderBottom: '1px solid #EEECF8',
    '& td': {
      fontSize: 12,
      color: '#4E4C4C',
      padding: '2px 5px 2px 0px',
      marginTop: '1px',
    },
    '&.selected': {
      //outline: 'auto',
      backgroundColor: '#DBD9E7',
      //outline: '1px solid #347CFF',
    },
    '&:hover': {
      background: '#eeecf8',
      '& .hidden-btn': {
        //display: 'flex',
      },
    },
  },
  tCell: {
    fontSize: 11,
    color: '#4c4c4c',
    marginRight: '10px',
    display: 'table-cell',
    verticalAlign: 'middle',
    fontWeight: 'inherit',
    padding: '2px',
    borderBottom: 'none',
    borderTop: 'none',
    '&:hover': {
      //background: '#EEECF8',
      '& .hidden-btn': {
        //display: 'flex',
      },
    },
    '&.selected': {
      backgroundColor: '#DBD9E7',
    },
  },
  columnHeadingGeneral: {
    padding: '2px 5px 2px 2px',
    fontSize: 11,
    color: '#6e6e98',
    textTransform: 'uppercase',
  },
  input: {
    maxHeight: '21px',
    minHeight: '21px',
    border: 'none',
    color: '#4E4C4C',
    fontSize: 12,
    background: '#e8ebf5',
    '&:hover': {
      background: '#D9D8ED',
    },
    '&:focus': {
      background: '#DBD9E7',
    },
    '&::placeholder': { color: '#7978A8', fontStyle: 'italic' },
  },
  actionIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    minHeight: '20px',
    width: 'max-content',
    padding: '2px',
    borderRadius: '20px',
    color: '#4c4c4c',
    cursor: 'pointer',
    outline: '1px solid #E6E5F1',
    '&:hover': {
      background: '#eeecf8',
      outline: '1px solid #D9D8ED',
    },
    '&.selected': {
      background: '#FFF',
    },
  },
  smallTabs: {
    minHeight: 0,
    zIndex: 50,
    height: 'fit-content',
    color: '#1B1920 !important',
    background: '#F2F1FB',
    borderRadius: '10px',
    outline: '1px solid #D9D8ED',
    marginTop: '1px',
    '& .MuiTab-root': {
      fontFamily: '"Open Sans", sans-serif !important',
      height: 'fit-content',
      minWidth: '40px',
      fontSize: 'smaller',
      minHeight: '16px',
      padding: '1px 6px',
      maxWidth: '140px',
      whiteSpace: 'nowrap',
      '-webkitAlignItems': 'start',
    },
    '& .Mui-selected': {
      border: '1px solid #4B4F73',
      borderRadius: '10px',
      backgroundColor: '#fff',
      fontFamily: '"Open Sans", sans-serif !important',
    },
    '& .MuiTab-wrapper': {
      fontSize: 10,
      flexDirection: 'row',
      textTransform: 'none',
    },
    '& .MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
      marginBottom: 0,
    },
    '& .MuiTabs-indicator': {
      height: '0px',
    },
  },
  smallestTabs: {
    minHeight: 0,
    zIndex: 50,
    height: 'fit-content',
    color: '#1B1920',
    background: '#F2F1FB',
    borderRadius: '8px',
    outline: '1px solid #D9D8ED',
    fontFamily: '"Open Sans", sans-serif !important',
    '& .MuiTab-root': {
      lineHeight: 1,
      height: 'fit-content',
      minWidth: '20px',
      fontSize: 'smaller',
      minHeight: '18px',
      padding: '1px 6px',
      maxWidth: '140px',
      whiteSpace: 'nowrap',
      '-webkitAlignItems': 'start',
    },
    '& .Mui-selected': {
      border: '1px solid #4B4F73',
      borderRadius: '8px',
      backgroundColor: '#fff',
    },
    '& .MuiTab-wrapper': {
      height: '1px',
      fontSize: 10,
      flexDirection: 'row',
      textTransform: 'none',
      fontFamily: '"Open Sans", sans-serif !important',
    },
    '& .MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
      marginBottom: 0,
    },
    '& .MuiTabs-indicator': {
      height: '0px',
    },
  },
  gradientBlackBtn: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 16px',
    width: 'fit-content',
    textTransform: 'none',
    borderRadius: '20px',
    position: 'relative',
    boxSizing: 'border-box',
    color: '#FFF',
    transition: '0.5s',
    backgroundImage: 'linear-gradient(to right, #000000 0%, #434343 51%, #000000 100%)',
    backgroundSize: '200% auto',
    color: 'white',
    boxShadow: '0 0 20px #eee',
    cursor: 'pointer',
    '&:hover': {
      backgroundPosition: 'center right',
      color: '#fff',
      textDecoration: 'none',
    },
  },
  actionBtn: {
    cursor: 'pointer',
    color: '#1B1920',
    minHeight: '32px',
    padding: '1px 20px',
    marginTop: 0,
    fontWeight: 400,
    fontSize: '12px',
    width: 'fit-content',
    height: 'fit-content',
    borderRadius: '20px',
    textTransform: 'none',
    background: '#F8FAFD',
    minWidth: '60px',
    boxShadow: 'none',
    border: '1px solid #E3E1F0',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#EEF0F3',
      border: '1px solid #D9D8ED',
    },
  },
  actionBtnBlack: {
    color: '#fff',
    opacity: 0.9,
    cursor: 'pointer',
    backgroundColor: '#1B1920',
    '&:hover': {
      backgroundColor: '#1B1920',
      opacity: 1
    },
  },
  secondaryBtn: {
    color: '#347CFF',
    fontSize: 11,
    flexShrink: '0',
    cursor: 'pointer',
    padding: '0 10px 2px',
    borderRadius: '5px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    backgroundColor: '#F7F7F7',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#eeecf8',
    },
  },
  thirdSmallBtn: {
    margin: 0,
    fontSize: 11,
    color: '#1B1920',
    minHeight: '20px',
    minWidth: '69px',
    padding: '3px 12px',
    backgroundColor: '#F1F1F6', 
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#E3E1F0'
    }
  },
  textInfo: {
    color: '#347CFF',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  white: {
    backgroundColor: '#fff',
  },
  halfTransparentWhite: {
    backgroundColor: 'rgba(255, 255, 255, 0.3) !important',
  },
  semiTansparentWhite: {
    backgroundColor: 'rgba(255, 255, 255, 0.7) !important',
  },
  transparent: {
    backgroundColor: 'transparent',
  },
  iconInfo: {
    marginLeft: '4px',
    fontSize: 12,
    color: '#347CFF',
    '&:hover': {
      color: '#347CFF !important',
      textDecoration: 'underline',
    },
  },
  pageHeading: {
    color: '#222029',
    padding: '20px 0px 5px 40px',
    backgroundColor: '#fff',
  },
  coloredBGWhiteBtn: {
    "&:after": {
      content: '""',
      position: "absolute",
      width: "90%",
      height: "80%",
      top: "25%",
      left: "0",
      right: "0",
      margin: "0 auto",
      zIndex: "-1",
      background: "linear-gradient(90deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%)",
      borderRadius: "inherit",
    },
  },
  helpText: {
    fontSize: 12,
    textDecoration: 'none',
    color: '#4c4c4c',//'grey',
  },
  helpAction: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#4c4c4c',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  glassBG: {
    background: 'rgba(253, 253, 255, 0.7)',
    borderRadius: '16px',
    padding: '8px',
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(7px)',
    '-webkit-backdrop-filter': 'blur(7px)',
    border: '1px solid rgba(255, 255, 255, 0.8)',
    willChange: 'transform',
  },
  glassBGMedium: {
    background: 'rgba(253, 253, 255, 1)', 
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 1px 5px rgba(0, 0, 0, 0.05)',
    // backdropFilter: 'blur(7px)',
    // '-webkit-backdrop-filter': 'blur(7px)',
    border: '1px solid rgba(255, 255, 255, 0.6)',
    willChange: 'transform',
  }
};
